export const en = {
    'accept-additions-confirm-groups':
        'Do you really want to ACCEPT all callouts linked to the selected ad groups without moderation?',
    'accept-additions-single-confirm-groups':
        'Do you really want to ACCEPT all callouts linked to the {name} ad group without moderation?',
    'accept-moderations-confirm-groups': 'Do you really want to ACCEPT the selected ad groups without moderation?',
    'accept-moderations-single-confirm-groups': 'Do you really want to ACCEPT the {name} ad group without moderation?',
    'actions-title': 'Actions',
    addToFavorites: 'Mark as important',
    admSendMD: 'Re-moderate',
    'all-banners-not-saved': 'Ads were not saved',
    'all-banners-saved': 'All ads have been saved successfully',
    archive: 'Archive',
    'archive-success': 'Campaigns archived',
    archiveBanner: 'Archive',
    'banner-archive-success': 'All selected banners have been added to the archive',
    'banner-archive-success-none': 'Unable to add the banners to the archive',
    'banner-archive-success-some': {
        one: '{count} of {allCount} banners added to the archive.',
        some: '{count} of {allCount} banners added to the archive.',
        many: '{count} of {allCount} banners added to the archive.',
        none: '{count} of {allCount} banners added to the archive.'
    },
    'banner-delete-success': 'All selected banners have been deleted',
    'banner-delete-success-none': 'Unable to delete the banners',
    'banner-delete-success-some': {
        one: '{count} of {allCount} banners deleted.',
        some: '{count} of {allCount} banners deleted.',
        many: '{count} of {allCount} banners deleted.',
        none: '{count} of {allCount} banners deleted.'
    },
    'banner-resume-success': 'Banner impressions have resumed',
    'banner-resume-success-none': 'Unable to resume banner impressions',
    'banner-resume-success-some': {
        one: 'Impressions resumed for {count} of {allCount} banners.',
        some: 'Impressions resumed for {count} of {allCount} banners.',
        many: 'Impressions resumed for {count} of {allCount} banners.',
        none: 'Impressions resumed for {count} of {allCount} banners.'
    },
    'banner-stop-success': 'Banners stopped',
    'banner-stop-success-none': 'Unable to stop banner impressions',
    'banner-stop-success-some': {
        one: '{count} of {allCount} banners stopped.',
        some: '{count} of {allCount} banners stopped.',
        many: '{count} of {allCount} banners stopped.',
        none: '{count} of {allCount} banners stopped.'
    },
    'banner-unarchive-success': 'All selected banners have been retrieved from the archive',
    'banner-unarchive-success-none': 'Unable to retrieve banners from the archive',
    'banner-unarchive-success-some': {
        one: '{count} of {allCount} banners retrieved from the archive.',
        some: '{count} of {allCount} banners retrieved from the archive.',
        many: '{count} of {allCount} banners retrieved from the archive.',
        none: '{count} of {allCount} banners retrieved from the archive.'
    },
    'banners-fail-saved': {
        one: '{count} ad was not changed',
        some: '{count} ads were not changed',
        many: '{count} ads were not changed',
        none: ''
    },
    'banners-organization-success-saved': {
        one: 'Company was changed successfully in {count} ad',
        some: 'Companies were changed successfully in {count} ads',
        many: 'Companies were changed successfully in {count} ads',
        none: '{count} ads saved successfully'
    },
    'banners-success-saved': {
        one: 'Prices changed in {count} ad',
        some: 'Prices changed in {count} ads',
        many: 'Prices changed in {count} ads',
        none: 'Prices changed in {count} ads'
    },
    'banners-universal-with-yt-limit':
        'Only the first {count} ads are selected because this is the maximum number that can be changed at once. You can filter ads to reduce the number of ads in the list.',
    'campaigns-added-to-favorites': 'Campaigns marked as important',
    'campaigns-delete-success': 'Campaigns deleted',
    'campaigns-removed-from-favorites': 'Campaigns removed from most important',
    'campaigns-universal-with-yt-limit':
        'Only the first {count} campaigns are selected because this is the maximum number that can be changed at once. You can filter campaigns to reduce the size of the list.',
    'change-feed-filter-autobudget-priority': 'Change priority',
    'change-feed-filter-rate': 'Set a bid',
    copy: 'Copy',
    'copy-disabled-info': "The selected groups can't be copied",
    'copy-disabled-info-cpm': 'Only select Display banner and Video groups',
    'copy-error': "Couldn't request copying",
    'copy-success': 'Copy ordered for selected campaigns',
    delete: 'Delete',
    'delete-confirm-banners': 'Are you sure you want to delete the selected ads?',
    'delete-confirm-campaigns': 'Are you sure you want to delete the selected campaigns?',
    'delete-confirm-feed-filters': 'Are you sure you want to delete the selected feed filters?',
    'delete-confirm-groups': 'Are you sure you want to delete the selected ad groups?',
    'delete-confirm-phrases': 'Are you sure you want to delete the selected keywords?',
    'delete-confirm-retargetings': 'Are you sure you want to delete the selected retargeting lists?',
    'delete-confirm-single-groups': 'Are you sure you want to delete the {name} group?',
    'delete-feed-filters': 'Delete',
    'delete-phrases': 'Delete',
    'delete-retargetings': 'Delete',
    deleteBanners: 'Delete',
    'disable-feed-filters': 'Disable',
    'disable-phrases': 'Stop',
    'edit-feed-filters': 'Edit',
    'edit-organization': 'Link a company from the Yandex Business Directory',
    editBanners: 'Edit',
    editBannersMass: 'Edit',
    editGroups: 'Edit',
    editPrices: 'Prices in ad',
    'enable-feed-filters': 'Enable',
    'enable-phrases': 'Enable',
    'export-to-excel': 'Export to Excel',
    'export-to-excel-with-banners': 'Export to Excel (with banners)',
    'export-to-excel-without-banners': 'Export to Excel (without banners)',
    'feed-filters-change-priority-error-any': 'Unable to update the feed filter priorities',
    'feed-filters-change-priority-error-one': 'Unable to update the feed filter priority',
    'feed-filters-change-priority-success-any': 'Successfully updated the priorities of all selected feed filters',
    'feed-filters-change-priority-success-one': 'Successfully updated the feed filter priority',
    'feed-filters-change-priority-warning': {
        one: 'Successfully updated priority for {count} of {totalCount} feed filters',
        some: 'Successfully updated priority for {count} out of {totalCount} feed filters',
        many: 'Successfully updated priority for {count} out of {totalCount} feed filters',
        none: ''
    },
    'feed-filters-change-rate-error-any': 'Unable to update feed filter bids',
    'feed-filters-change-rate-error-one': 'Unable to update feed filter bid',
    'feed-filters-change-rate-success-any': 'Successfully updated bids of all selected feed filters',
    'feed-filters-change-rate-success-one': 'Successfully updated feed filter bid',
    'feed-filters-change-rate-warning': {
        one: 'Successfully updated bid for {count} out of {totalCount} feed filters',
        some: 'Successfully updated bid for {count} out of {totalCount} feed filters',
        many: 'Successfully updated bid for {count} out of {totalCount} feed filters',
        none: ''
    },
    'feed-filters-delete-error-any': 'Unable to delete feed filters',
    'feed-filters-delete-error-one': 'Unable to delete the feed filter',
    'feed-filters-delete-success-any': 'Successfully deleted all selected feed filters',
    'feed-filters-delete-success-one': 'Feed filter deleted successfully',
    'feed-filters-delete-warning': {
        one: 'Successfully deleted {count} out of {totalCount} feed filters',
        some: 'Successfully deleted {count} out of {totalCount} feed filters',
        many: 'Successfully deleted {count} out of {totalCount} feed filters',
        none: ''
    },
    'feed-filters-disable-error-any': 'Unable to disable the feed filters',
    'feed-filters-disable-error-one': 'Unable to disable the feed filter',
    'feed-filters-disable-success-any': 'Successfully disabled all selected feed filters',
    'feed-filters-disable-success-one': 'Successfully disabled the feed filter',
    'feed-filters-disable-warning': {
        one: 'Successfully disabled {count} out of {totalCount} feed filters',
        some: 'Successfully disabled {count} out of {totalCount} feed filters',
        many: 'Successfully disabled {count} out of {totalCount} feed filters',
        none: ''
    },
    'feed-filters-enable-error-any': 'Unable to enable the feed filters',
    'feed-filters-enable-error-one': 'Unable to enable the feed filter',
    'feed-filters-enable-success-any': 'Successfully enabled all of the selected feed filters',
    'feed-filters-enable-success-one': 'Successfully enabled the feed filter',
    'feed-filters-enable-warning': {
        one: 'Successfully enabled {count} out of {totalCount} feed filters',
        some: 'Successfully enabled {count} out of {totalCount} feed filters',
        many: 'Successfully enabled {count} out of {totalCount} feed filters',
        none: ''
    },
    'feed-filters-universal-with-yt-limit':
        'Only the first {count} filters have been selected because this is the maximum number you can change at once. You can use filtering to reduce the size of the list.',
    goToBanners: 'Ads',
    goToGroups: 'Ad groups',
    goToLogs: 'Changelog',
    goToMol: 'Go to Report Wizard',
    goToPhrases: 'Keywords',
    goToTargeting: 'Impression criteria',
    'group-adm-send-md-error': 'Unable to submit ad groups for re-moderation',
    'group-adm-send-md-success': 'Ad groups submitted for re-moderation',
    'group-archive-success': 'All selected ad groups have been archived',
    'group-archive-success-none': 'Unable to add ad groups to the archive',
    'group-archive-success-some': {
        one: '{count} of {allCount} ad groups added to the archive.',
        some: '{count} of {allCount} ad groups added to the archive.',
        many: '{count} of {allCount} ad groups added to the archive.',
        none: '{count} of {allCount} ad groups added to the archive.'
    },
    'group-can-not-be-accept-moderation-additions': 'No ad groups matching the operation',
    'group-can-not-be-adm-send-md': 'No ad groups matching the operation',
    'group-can-not-be-moderate-accept': 'No ad groups matching the operation',
    'group-can-not-be-remoderate-additions': 'No ad groups matching the operation',
    'group-can-not-be-send-moderate': 'No ad groups matching the operation',
    'group-can-not-regions-transform': 'No ad groups match the operation',
    'group-can-not-sendBK': 'No ad groups matching the operation',
    'group-delete-success': 'Ad groups deleted',
    'group-delete-success-none': 'Unable to delete ad groups',
    'group-delete-success-some': {
        one: '{count} of {allCount} ad groups deleted',
        some: '{count} of {allCount} ad groups deleted',
        many: '{count} of {allCount} ad groups deleted',
        none: '{count} of {allCount} ad groups deleted'
    },
    'group-exceeded-max-size': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-accept-moderation-additions': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-adm-send-md': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-copy': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-delete': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-moderate-accept': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-regions-transform': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-remoderate-additions': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-send-moderate': 'The number of selected groups must be less than 1000',
    'group-exceeded-max-size-to-sendBK': 'The number of selected groups must be less than 1000',
    'group-moderate-accept-banners-additions-error': 'Unable to submit ad groups to accept callout moderation',
    'group-moderate-accept-banners-additions-success': 'Ad groups submitted to accept callout moderation',
    'group-moderate-accept-banners-additions-success-some': {
        one: '{count} of {allCount} ad groups submitted to accept callout moderation',
        some: '{count} of {allCount} ad groups submitted to accept callout moderation',
        many: '{count} of {allCount} ad groups submitted to accept callout moderation',
        none: '{count} of {allCount} ad groups submitted to accept callout moderation'
    },
    'group-moderate-accept-error': 'Unable to submit ad groups to accept moderation',
    'group-moderate-accept-success': 'Ad groups submitted to accept moderation',
    'group-remoderate-banners-additions-error': 'Unable to submit ad groups for callout re-moderation',
    'group-remoderate-banners-additions-success': 'Ad groups submitted for callout re-moderation',
    'group-remoderate-banners-additions-success-some': {
        one: '{count} of {allCount} ad groups submitted for callout re-moderation',
        some: '{count} of {allCount} ad groups submitted for callout re-moderation',
        many: '{count} of {allCount} ad groups submitted for callout re-moderation',
        none: '{count} of {allCount} ad groups submitted for callout re-moderation'
    },
    'group-resume-success': 'Impressions resumed for all selected ad groups',
    'group-resume-success-none': 'Unable to resume impressions of ad groups',
    'group-resume-success-some': {
        one: 'Impressions resumed for {count} of {allCount} ad groups.',
        some: 'Impressions resumed for {count} of {allCount} ad groups.',
        many: 'Impressions resumed for {count} of {allCount} ad groups.',
        none: 'Impressions resumed for {count} of {allCount} ad groups.'
    },
    'group-send-moderate-error': 'Unable to submit ad groups for moderation',
    'group-send-moderate-success': 'Ad groups submitted for moderation',
    'group-send-moderate-success-some': {
        one: '{count} of {allCount} ad groups submitted for moderation',
        some: '{count} of {allCount} ad groups submitted for moderation',
        many: '{count} of {allCount} ad groups submitted for moderation',
        none: '{count} of {allCount} ad groups submitted for moderation'
    },
    'group-sendBK-error': 'Unable to upload ad groups to BS',
    'group-sendBK-success': 'Ad groups uploaded to BS',
    'group-single-adm-send-md-error': 'Unable to submit ad group {name} for re-moderation',
    'group-single-adm-send-md-success': 'Ad group {name} submitted for re-moderation',
    'group-single-delete-error': 'Unable to delete ad group {name}',
    'group-single-delete-success': 'Ad group {name} deleted',
    'group-single-moderate-accept-banners-additions-error':
        'Unable to submit ad group {name} to accept callout moderation',
    'group-single-moderate-accept-banners-additions-success': 'Ad group {name} submitted to accept callout moderation',
    'group-single-moderate-accept-error': 'Unable to submit ad group {name} to accept moderation',
    'group-single-moderate-accept-success': 'Ad group {name} submitted to accept moderation',
    'group-single-remoderate-banners-additions-error': 'Unable to submit ad group {name} for callout re-moderation',
    'group-single-remoderate-banners-additions-success': 'Ad group {name} submitted for callout re-moderation',
    'group-single-send-moderate-error': 'Unable to submit ad group {name} for moderation',
    'group-single-send-moderate-success': 'Ad group {name} submitted for moderation',
    'group-single-sendBK-error': 'Unable to upload ad group {name} to BS',
    'group-single-sendBK-success': 'Ad group {name} uploaded to BS',
    'group-stop-success': 'All selected ad groups have been stopped',
    'group-stop-success-none': 'Unable to stop impressions of ad groups',
    'group-stop-success-some': {
        one: '{count} of {allCount} ad groups stopped.',
        some: '{count} of {allCount} ad groups stopped.',
        many: '{count} of {allCount} ad groups stopped.',
        none: '{count} of {allCount} ad groups stopped.'
    },
    'group-unarchive-success': 'All selected ad groups have been retrieved from the archive',
    'group-unarchive-success-none': 'Unable to retrieve ad groups from the archive',
    'group-unarchive-success-some': {
        one: '{count} of {allCount} ad groups retrieved from the archive.',
        some: '{count} of {allCount} ad groups retrieved from the archive.',
        many: '{count} of {allCount} ad groups retrieved from the archive.',
        none: '{count} of {allCount} ad groups retrieved from the archive.'
    },
    'groups-universal-with-yt-limit':
        'Only the first {count} ad groups are selected because this is the maximum number that can be changed at once. You can filter ad groups to reduce the size of the list.',
    'internal-tool-title': 'Internal tools',
    moderate: 'Send to moderation',
    moderateAccept: 'Accept moderation',
    moderateAcceptBannersAdditions: 'Moderation: accept callouts',
    'no-editable': 'Editing is not available',
    'one-banners-not-saved': "Couldn't save ad",
    'one-banners-saved': 'Ad saved',
    'open-search-and-replace-inspector': 'Find and replace',
    openMinusPhraseSelector: 'Configure sets of negative keywords',
    openMinusPhraseSelectorDisabledInfo: 'Select ad groups only for Text & Image Ad and Search banner campaigns',
    openMinusPhraseSelectorNoRights: 'No permission to configure the sets of negative keywords',
    openMinusPhraseSelectorOverMaxInfo: 'Number of selected ad groups must be less than {count}',
    openPhrasesSelectorWizard: 'Select keywords',
    payByCash: 'Top up with cash',
    'phrases-delete-success': 'Keywords deleted',
    'phrases-disable-success': 'Keywords stopped',
    'phrases-enable-success': 'Keywords enabled',
    'phrases-set-common-price-error-all': 'Unable to set the bid',
    'phrases-set-common-price-error-one': 'Unable to set the bid',
    'phrases-set-common-price-success-all': 'Bid set',
    'phrases-set-common-price-success-one': 'Bid set',
    'phrases-set-common-price-warning': {
        one: 'Bid set for {count} of {totalCount} keywords',
        some: 'Bid set for {count} of {totalCount} keywords',
        many: 'Bid set for {count} of {totalCount} keywords',
        none: 'Bid set for {count} of {totalCount} keywords'
    },
    'phrases-universal-with-yt-limit':
        'Only the first {count} keywords were selected: you can not change more at once. You can reduce the number of keywords in the list by using a filter.',
    'phrases-wizard-data-set-none': 'Bids have not been applied to any keywords',
    'phrases-wizard-data-set-success':
        'New bids have been set successfully for {setCount} of {phrasesCount} keywords. Activation will take about 30 minutes.',
    'phrases-wizard-data-set-success-with-yt-limit':
        'New bids have been set successfully for {setCount} keywords of {phrasesCount}. Activation will take about 30 minutes. The other keywords were not selected due to a technical limitation. Filter these keywords by status and set the bids again.',
    pricesWizard: 'Bid Wizard',
    'regions-transform': 'Configure display regions',
    'regions-transform-access-error': "You don't have the necessary permissions to configure display regions",
    remoderate: 'Re-moderate',
    'remoderate-success': 'Campaigns submitted for re-moderation',
    remoderateBannersAdditions: 'Re-moderate callouts',
    removeFromFavorites: 'Remove from most important',
    resume: 'Resume impressions',
    'resume-retargetings': 'Activate',
    'resume-success': 'Campaign impressions resumed',
    resumeBanner: 'Resume impressions',
    'retargetings-delete-error-all': 'Unable to delete retargeting lists',
    'retargetings-delete-error-one': 'Unable to delete the retargeting list',
    'retargetings-delete-success-all': 'All selected retargeting lists deleted',
    'retargetings-delete-success-one': 'Retargeting list deleted',
    'retargetings-delete-warning-some': {
        one: '{count} of {totalCount} retargeting lists deleted',
        some: '{count} of {totalCount} retargeting lists deleted',
        many: '{count} of {totalCount} retargeting lists deleted',
        none: '{count} of {totalCount} retargeting lists deleted'
    },
    'retargetings-resume-error-all': 'Unable to resume the retargeting lists',
    'retargetings-resume-error-one': 'Unable to resume the retargeting list',
    'retargetings-resume-success-all': 'All selected retargeting lists have been resumed',
    'retargetings-resume-success-one': 'The retargeting list has been resumed',
    'retargetings-resume-warning-some': {
        one: '{count} of {totalCount} retargeting lists resumed',
        some: '{count} of {totalCount} retargeting lists resumed',
        many: '{count} of {totalCount} retargeting lists resumed',
        none: '{count} of {totalCount} retargeting lists resumed'
    },
    'retargetings-set-common-price-error-all': 'Unable to set the bid',
    'retargetings-set-common-price-error-one': 'Unable to set the bid',
    'retargetings-set-common-price-success-all': 'Bid set',
    'retargetings-set-common-price-success-one': 'Bid set',
    'retargetings-set-common-price-warning-some': {
        one: 'Bid set for {count} of {totalCount} retargeting lists',
        some: 'Bid set for {count} of {totalCount} retargeting lists',
        many: 'Bid set for {count} of {totalCount} retargeting lists',
        none: 'Bid set for {count} of {totalCount} retargeting lists'
    },
    'retargetings-suspend-error-all': 'Unable to stop the retargeting lists',
    'retargetings-suspend-error-one': 'Unable to stop the retargeting list',
    'retargetings-suspend-success-all': 'All selected retargeting lists have been stopped',
    'retargetings-suspend-success-one': 'Retargeting list stopped',
    'retargetings-suspend-warning-some': {
        one: '{count} of {totalCount} retargeting lists stopped',
        some: '{count} of {totalCount} retargeting lists stopped',
        many: '{count} of {totalCount} retargeting lists stopped',
        none: '{count} of {totalCount} retargeting lists stopped'
    },
    'retargetings-universal-with-yt-limit':
        'Only the first {count} display rules are selected because this is the maximum number that can be changed at once. You can use a filter to reduce the size of the list.',
    sendBK: 'Send to banner system (BS)',
    'sendBK-confirm-groups': 'Are you sure you want to upload the selected ad groups to BS?',
    'sendBK-confirm-single-groups': 'Are you sure you want to upload ad group {name} to BS?',
    sendModerate: 'Send to moderation',
    sendModerateByClient: 'Send to moderation',
    'set-common-price': 'Set a single bid',
    'status-title': 'Status',
    stop: 'Stop',
    'stop-success': 'Campaigns stopped',
    stopBanner: 'Stop',
    'suspend-retargetings': 'Stop',
    'tool-title': 'Tools',
    unarchive: 'Unarchive',
    'unarchive-success': 'Campaigns have been unarchived',
    unarchiveBanner: 'Unarchive',
    'unknown-error': 'Unknown error',
    'users-profile-universal-with-yt-limit':
        'Only the first {count} display rules are selected because this is the maximum number that can be changed at once. You can use a filter to reduce the size of the list.'
};
